export default __webpack_public_path__ + "static/media/Altaport_Services_Agreement_EN.c322829c.pdf";